module.exports = __webpack_public_path__ + "img/2020y_top1.e105d106.jpg";